import { development } from './es/development';
import { common } from './es/common';
import { sidebar } from './es/sidebar';
import { auth } from './es/auth';
import { dashboard } from './es/dashboard';
import { products } from './es/products';
import { inventory } from './es/inventory';
import { movements } from './es/movements';
import { reports } from './es/reports';
import { settings } from './es/settings';
import { users } from './es/users';
import { table } from './es/table';

export const es = {
  development,
  common,
  sidebar,
  auth,
  dashboard,
  products,
  inventory,
  movements,
  reports,
  settings,
  users,
  table,
} as const;
